<template>
  <f-p-payment-layout
    :type="type"
    :guid="guid"
    :payNow="payNow"
    :bluredProp="bluredProp"
    :isAlreadyPaid="isAlreadyPaid"
    :isLoadingPayNow="isLoadingPayNow"
    :isLoadingAdd="isLoadingAdd"
    :isLoadingAlreadyPaid="isLoadingAlreadyPaid"
    @alreadyPaid="alreadyPaid"
    @loadingPayNow="loadingPayNow"
    @loadingAdd="loadingAdd"
    @loadingAlreadyPaid="loadingAlreadyPaid"
    @clearInputErrorsPayments="clearInputErrorsPayments"
    @clearOthersPayments="clearOthersPayments"
    @checkAnyInput="checkAnyInput"
    ref="layout"
  >
    <template #paymentButtons>
      <div class="section-bottom">
        <hr class="horizontal-line">

        <!-- CANCEL -->
        <f-p-cancel-button :breadcrumbTo="'Unpaid'" :cancelTitle="$lang.messages.cancel"></f-p-cancel-button>

        <!-- PAY NOW -->
        <div class="button-pay-now">
          <button
            v-if="actionType === 'add'"
            class="action-btn"
            :disabled="isPayDisabled || isAlreadyPaid"
            :class="{ 'disabled': isPayDisabled || isAlreadyPaid }"
            @click="payingNow"
          >
            <span v-show="!isLoadingPayNow">{{ $lang.messages.payNow }}</span>
            <ClipLoader :loading="isLoadingPayNow" :color="'#fff'" :size="'20px'" />
          </button>
          <span class="not-payable-reason" v-if="isPayDisabled || isAlreadyPaid">
            {{ notPayableReasonMessage }}
          </span>
        </div>

        <!-- ADD -->
        <button type="submit" v-if="actionType === 'add'" class="action-btn">
          <span v-show="!isLoadingAdd">{{ $lang.messages.addPayment }}</span>
          <ClipLoader :loading="isLoadingAdd" :color="'#fff'" :size="'20px'" />
        </button>

        <!-- ALREADY PAID -->
        <button type="submit" v-if="actionType === 'add'" class="action-btn" @click="handleAlreadyPaid">
          <span v-show="!isLoadingAlreadyPaid">{{ $lang.messages.alreadyPaid }}</span>
          <ClipLoader :loading="isLoadingAlreadyPaid" :color="'#fff'" :size="'20px'" />
        </button>
  
        <!-- EDIT -->
        <div class="button-pay-now">
          <button type="submit" v-if="actionType === 'edit'" class="action-btn">
            <span v-show="!isLoadingAdd">{{ $lang.messages.save }}</span>
            <ClipLoader :loading="isLoadingAdd" :color="'#fff'" :size="'20px'" />
          </button>
        </div>
      </div>
    </template>

  </f-p-payment-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { GET_PAYABLE_FROM } from "../../store/action.types";
  import FPPaymentLayout from "./FPAddPaymentLayout";
  import ClipLoader from 'vue-spinner/src/ClipLoader';
  import FPDatepicker from '@/components/common/FPDatepicker';
  import FPCancelButton from "@/components/common/FPCancelButton";

  export default {
    name: "FPAddPayment",
    components: {
      'f-p-payment-layout': FPPaymentLayout,
      ClipLoader,
      'f-p-datepicker': FPDatepicker,
      'f-p-cancel-button': FPCancelButton
    },
    props: {
      type: {
        type: String,
        required: true,
        default: () => {
          return '';
        }
      },
      guid: {
        type: String,
        required: true,
        default: () => {
          return '';
        }
      },
      bluredProp: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        payNow: false,
        isPayDisabled: false,
        isAlreadyPaid: false,
        isLoadingPayNow: false,
        isLoadingAdd: false,
        isLoadingAlreadyPaid: false,
        notPayableReasonMessage: '',
        actionType: ''
      }
    },
    computed: {
      ...mapGetters(['IS_PAYABLE_FROM_GETTER'])
    },
    beforeMount() {
      this.$root.$on('pay-disabled', value => {
        this.isPayDisabled = value.prop;
        this.notPayableReasonMessage = value.text;
      });
    },
    mounted() {
      this.$root.$on('paying-now', this.payingNow);
      this.actionType = this.$refs.layout.actionType;
    },
    destroyed() {
      this.$root.$off('paying-now', this.payingNow);
    },
    methods: {
      ...mapActions({
        GET_PAYABLE_FROM
      }),
      handleAlreadyPaid() {
        this.isAlreadyPaid = true;
        // When user pay the expense with "Already paid" button, we need to change the breadcrumb to History
        this.$store.dispatch('GET_PAYABLE_FROM', true)
      },
      payingNow() {
        this.payNow = true
      },
      alreadyPaid (val) {
        this.isAlreadyPaid = val
      },
      loadingPayNow (val) {
        this.isLoadingPayNow = val
      },
      loadingAdd (val) {
        this.isLoadingAdd = val
      },
      loadingAlreadyPaid (val) {
        this.isLoadingAlreadyPaid = val
      },
      clearInputErrorsPayments (val) {
        this.$emit('clearInputErrorsPayments', val)
      },
      clearOthersPayments (val) {
        this.$emit('clearOthersPayments', val)
      },
      checkAnyInput () {
        this.$emit('checkAnyInput')
      }
    }
  }
</script>
